
import { Component, Input, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

import { CarouselItemComponent } from './carousel-item/carousel-item.component';
import { BaseWidgetComponent } from '../../../shared/base.component';

export interface ICarouselSettings {
    items: {
        mobile: number;
        tablet: number;
        desktop: number;
    }
    break: {
        mobile: number;
        tablet: number;
    }
}

@Component({
    selector: 'carousel',
    template: `
<div [class]="'carousel' + (klass ? ' ' + klass : '')" widget (window:resize)="resize()">
    <div class="arrow previous" [class.disabled]="index <= 0" (touchrelease)="index <= 0 ? '' : change(-1)"></div>
    <div class="body">
        <div class="content" [style.transform]="'translateX(' + ((100 / model.count) * -index) + '%)'">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="arrow next" [class.disabled]="index >= model.item_cnt - model.count" (touchrelease)="index >= model.item_cnt - model.count ? '' : change(1)"></div>
</div>
`,
    styles: [`carousel:host{width:100%;height:100%}.carousel{position:relative;width:calc(100% - 3em);min-width:8em;min-height:9em;height:100%;margin:auto}.body{position:relative;height:100%;width:100%;overflow:hidden}.content{position:absolute;top:0;left:0;right:0;bottom:0;overflow:visible;white-space:nowrap;-webkit-transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.arrow{position:absolute;top:50%;height:2em;width:2em;background-color:#fff;border-radius:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-position:center;background-repeat:no-repeat;background-size:contain;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);border:1px solid #fff;-webkit-transition:border .3s,-webkit-box-shadow .3s;transition:border .3s,box-shadow .3s,-webkit-box-shadow .3s;z-index:200}.arrow:hover{-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12);box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12)}.arrow:active{border-color:#f0f0f0;-webkit-box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent;box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent}.arrow.previous{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNMTUuNDEsMTYuNTlMMTAuODMsMTJsNC41OC00LjU5TDE0LDZsLTYsNmw2LDZMMTUuNDEsMTYuNTl6Ii8+CjxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wLDBoMjR2MjRIMFYweiIvPgo8L3N2Zz4K);left:0;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.arrow.next{background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNOC41OSwxNi41OUwxMy4xNywxMkw4LjU5LDcuNDFMMTAsNmw2LDZsLTYsNkw4LjU5LDE2LjU5eiIvPgo8cGF0aCBmaWxsPSJub25lIiBkPSJNMCwwaDI0djI0SDBWMHoiLz4KPC9zdmc+Cg==);right:0;-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.arrow.disabled{border-color:#f0f0f0;-webkit-box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent;box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent;opacity:.54}`]
})
export class CarouselComponent extends BaseWidgetComponent implements OnChanges, OnDestroy, AfterContentInit {
    @Input() public name: string;
    @Input() public index: number = 0;
    @Input() public settings: ICarouselSettings;
    @Output() public indexChange = new EventEmitter();
    @Output() public select = new EventEmitter();

    public model: { [name: string]: any } = {};

    @ContentChildren(CarouselItemComponent) private items: QueryList<CarouselItemComponent>;

    constructor() {
        super();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.settings) {
            this.resize();
        }
    }

    public ngAfterContentInit() {
        if (this.subs.obs.items) {
            this.subs.obs.items instanceof Function ? this.subs.obs.items() : this.subs.obs.items.unsubscribe();
            this.subs.obs.items = null;
            this.index = 0;
        }
        this.subs.obs.items = this.items.changes.subscribe(() => this.init());
        this.init();
    }

    public init() {
        this.timeout('init', () => {
                // Initialise items
            if (this.items) {
                const list = this.items.toArray();
                for (const item of list) {
                    item.parent = this;
                    item.model.index = list.indexOf(item);
                }
                this.model.item_cnt = list.length;
            }
        }, 150);
        this.resize();
    }

    /**
     * Update the positioning
     * @param value Value to change the offset index
     */
    public change(value: number = 0) {
        if (!this.model.pending) { this.model.pending = 0; }
        this.model.pending += value;
        this.timeout('change', () => {
            if (!this.model.pending) {
                this.index = 0;
            } else {
                this.index += this.model.pending;
            }
            if (this.index < 0) { this.index = 0; }
            if (this.items) {
                const list = this.items.toArray();
                if (this.index >= list.length) { this.index = list.length - 1; }
                for (const item of list) {
                    item.model.offset = this.index;
                }
            }
            this.indexChange.emit(this.index);
            this.model.pending = 0;
        }, 50);
    }

    /**
     * Post interaction with child elements
     * @param index Index of the item
     */
    public tap(index: number) {
        if (this.items) {
            const list = this.items.toArray();
            if (index < list.length && index >= 0) {
                this.select.emit(index);
            }
        }
    }

    /**
     * Update display when the window is resized
     */
    public resize() {
        this.timeout('resize', () => {
            this.model.count = 0;
            const landscape = window.innerHeight <= window.innerWidth;
            let w = window.innerWidth;
            let device = 'desktop';
                // Get biggest dimension
            if (!landscape) {
                w = window.innerHeight;
            }
                // Get breakpoints
            const mobile_break = (this.settings && this.settings.break ? this.settings.break.mobile || 840 : 840);
            const tablet_break = (this.settings && this.settings.break ? this.settings.break.tablet || 1024 : 1024);
            if (w <= mobile_break) { device = 'mobile'; }
            else if (w <= tablet_break) { device = 'tablet'; }
                // Update item display settings
            if (this.settings && this.settings.items) {
                this.model.count = this.settings.items[device];
            }
                // Get breakpoint display counts
            const mobile_count = (this.settings && this.settings.items ? this.settings.items.mobile || 2 : 2);
            const tablet_count = (this.settings && this.settings.items ? this.settings.items.tablet || 3 : 3);
            const desktop_count = (this.settings && this.settings.items ? this.settings.items.desktop || 5 : 5);
            if (!this.model.count) {
                this.model.count = device === 'desktop' ? desktop_count : (device === 'tablet' ? tablet_count : mobile_count);
            }
                // Update carousel items
            if (this.items) {
                const list = this.items.toArray();
                for (const item of list) {
                    item.model.width = 1 / this.model.count;
                    item.model.count = this.model.count;
                    item.updateWidth();
                }
            }
        }, 100);
    }
}